<template>
  <div class="guideResultBox">
    <div v-for="(item, index) in GuideLablesConfig" :key="index">
      <div class="resultItem" v-if="result[item.key]">
        <div class="title u-flex u-col-center">
          <span class="spot"></span>
          <span>{{ item.label }}</span>
        </div>
        <div
          class="content imgBox"
          v-if="item.key === 'imageList'"
          :style="{ paddingTop: result.imageList.length ? '10px' : '0' }"
        >
          <a-image-preview-group v-if="result.imageList && result.imageList.length">
            <auth-img
              mode="ant"
              v-for="(img, index) in result.imageList || []"
              :key="index"
              :src="img"
              class="imgs"
            />
          </a-image-preview-group>
          <span v-else>无</span>
        </div>
        <div class="content intentDoctor" v-else-if="item.key === 'intentionMedicalDoctor'">
          <div class="doctorName">
            <span>
              {{ result.intentionMedicalDoctor }}
              <span v-if="result.intentionMedicalDoctor && result.intentionMedicalDoctor !== '无'">
                医生
              </span>
            </span>
          </div>
          <div
            class="doctorBelong"
            v-if="result.intentionMedicalDoctor && result.intentionMedicalDoctor !== '无'"
          >
            {{
              result.intentionMedicalDepartment === '无'
                ? '科室不详'
                : result.intentionMedicalDepartment
            }}
            ｜
            {{
              result.intentionMedicalHospital === '无'
                ? '医院不详'
                : result.intentionMedicalHospital
            }}
          </div>
        </div>
        <div class="content" v-else>{{ result[item.key] }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { GuideLablesConfig } from './config'

const props = defineProps({
  contents: {
    type: String,
    default: ''
  }
})
const result = JSON.parse(props.contents)
</script>

<style lang="scss" scoped>
.guideResultBox {
  width: 100%;
  padding: 12px 12px 0 12px;

  .resultItem {
    margin-bottom: 16px;
    font-size: 14px;

    .title {
      font-weight: 500;
      color: #1a1a1a;
      margin-bottom: 4px;
    }

    .spot {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #4c6ee0;
      border-radius: 6px;
      margin-right: 6px;
    }

    .content {
      font-weight: 400;
      color: #3b3b3b;
      padding-left: 12px;
    }

    .imgBox {
      display: flex;
      flex-wrap: wrap;
      padding-top: 10px;
    }

    .imgs {
      width: 48px;
      height: 48px;
      margin: 0 10px 10px 0;
    }

    .intentDoctor {
      background: #f7f7f7;
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 14px;

      .doctorName {
        font-weight: 500;
        color: #3b3b3b;
        .doIcon {
          width: 16px;
          height: auto;
          margin-left: 2px;
          font-size: 16px;
          color: #25bca2;
        }
      }

      .doctorBelong {
        font-weight: 400;
        color: #7d7d7d;
      }
    }
  }
}
</style>
